import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { LegalRecordStateService } from "@core/services/utils/legal-record-state.service";
import { IconDisplayComponent } from "@ui/ui-helpers/display-formats/icon-display/icon-display.component";

@Component({
  selector: "mobile-nav",
  templateUrl: "./mobile-nav.component.html",
  styleUrl: "./mobile-nav.component.scss",
  imports: [IconDisplayComponent],
})
export class MobileNavComponent {
  private router = inject(Router);
  private readonly legalRecordStateService = inject(LegalRecordStateService);

  goHome() {
    const recordId = this.legalRecordStateService.getCurrentRecordId();
    if (recordId) {
      this.router.navigate([`/records/${recordId}`]);
    } else {
      this.router.navigate(["/records"]);
    }
  }

  goMessages() {
    this.router.navigate(["/messaging"]);
  }

  goHistory() {
    const recordId = this.legalRecordStateService.getCurrentRecordId();
    if (recordId) {
      this.router.navigate([`/records/${recordId}/history`]);
    } else {
      this.router.navigate(["/records"]);
    }
  }

  isHistoryActive(): boolean {
    return this.router.url.includes("/history");
  }

  isMessagesActive(): boolean {
    return this.router.url.includes("/messaging");
  }

  isHomeActive(): boolean {
    return !this.isHistoryActive() && this.router.url.includes("/records");
  }
}
